module.exports = {"data":{"mapsJson":{"name":"Big Game Hunters","description":"Each player gets an extra [2 gold] during each of their upkeeps.","filename":"map_big_game_hunters.jpg","slug":"big_game_hunters"},"site":{"siteMetadata":{"title":"Codex Card Database"}}},"pathContext":{"slug":"big_game_hunters","imageRegex":"/big_game_hunters.jpg/"}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/map-big-game-hunters.json
// module id = 1237
// module chunks = 217434727830007